import { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { Space } from "antd";
import { LazyLoadImage } from "react-lazy-load-image-component";

import MenuIcon from "../../../assets/img/icons/nav/Share.svg";
import AddIcon from "../../../assets/img/icons/addicon.svg";
import MinusIcon from "../../../assets/img/icons/minusIcon.svg";
import FavouriteIcon from "../../Common/Components/ArticleFavouriteIcon";
import FavouriteIconTwo from "../../Common/Components/ArticleFavouriteIconTwo";
import { RootState } from "store";

/* social media  */
import ShareMenuPopup from "./ShareMenuPopup";
import ContentEngagementPill from "../../Common/Components/ContentEngagementPill";
import CMSPill from "../../Common/Components/CMSPill";
import { getImageUrl } from "../../../utils";
import { openArticleSidebarPreview } from "../../GlobalActions";
import { addArticlesToEmailInEmailBrowser } from "../../EmailBrowser/actions";
import { getQueryCampaignId, getQueryEmailId } from "./../../EmailBrowser/utils";
// import ArticlePreviewSidebar from "modules/Content/Shared/ArticlePreviewSidebar";

import LargeCheckBox from "modules/Content/Shared/LargeCheckBox";
import ThemePill from "./ThemePill";
import NewEngagementPill from "./NewEngagementPill";
import CuratedPill from "./CuratedPill";
import { addFavouriteArticle, removeFavoriteArticle } from "modules/Content/Favorites/actions";
import { getEmptyImage } from "react-dnd-html5-backend";
import store from "store";
import { DRAG_DROP, SEARCH_ARTICLES } from "constants/actionTypes";
import { useSelector } from "react-redux";
import { uncheckWhnArticle, checkWhnArticle } from "../../Content/WhatsHappeningNow/actions";
import { showTooltipPopupFirstTime } from "modules/Login/action";
import { setContentExplorerBlogItemId, setContentExplorerStep } from "modules/OnBoarding/actions";
import EmailBrowser from "modules/EmailBrowser/EmailBrowser";
import { useLocation } from "react-router-dom";

const CheckBlogItem = (props) => {
  const {
    articleId,
    title,
    website,
    tags,
    publishDate,
    smallBlog,
    imgUrl,
    imgHeight,
    imgHeightSm,
    isFav,
    isCMS,
    is_loading,
    is_removingFailed,
    isCurated,
    entities,
    companyLogo,
    isBeingDragged,
    selectedArticle,
    preview,
    isDraggable,
    inEditionSmartSourced,
    categoryColor,
    categoryTitle,
    companyName,
    description,
    link,
    fullDescription,
  } = props;
  const [imgWidth, setimgWidth] = useState({});
  const imgDiv = useRef(null);
  const selectedArticles = useSelector((state) => state.dragDrop.selectedIds);
  const [isChecked, SetIsChecked] = useState(preview || selectedArticles.includes(articleId) ? true : isDraggable);
  const isTooltipAlreadyShowedFirstTime = useSelector((state) => state.user.isTooltipAlreadyShowedFirstTime);
  const contentExplorer = useSelector((state) => state.user.contentExplorer);
  const contentExplorerStep = useSelector((state) => state.user.contentExplorerStep);
  const parameters = window.location.search.split("&");
  const location = useLocation();
  const isFavoritesPage =
    location.pathname.includes("favorites") && location.search.includes("email_id") && getQueryEmailId() !== 0;

  const { searchTerms } = useSelector((state) => state.previewArticle);
  const [articleSearchedTerms, setArticleSearchedTerms] = useState([]);
  const [modifiedArticleSearchedTerms, setModifiedArticleSearchedTerms] = useState([]);

  useEffect(() => {
    SetIsChecked(selectedArticles.includes(articleId));
  }, [selectedArticles]);
  useEffect(() => {
    if (imgDiv.current) {
      let width = imgDiv.current.offsetWidth;
      setimgWidth(width);
    }
  }, []);

  const curateCheckBlog = (e) => {
    store.dispatch({
      type: DRAG_DROP.SET_SELECTED_ID,
      payload: { add: !isChecked, id: articleId },
    });

    if (!isTooltipAlreadyShowedFirstTime) {
      showTooltipPopupFirstTime();
    }
    SetIsChecked(!isChecked);
  };

  const addArticleToDraft = (article_id, _articleObj) => {
    const campaignId = getQueryCampaignId();
    const emailId = getQueryEmailId();
    addArticlesToEmailInEmailBrowser(emailId, article_id, campaignId, _articleObj);
  };

  const occurrences = (string, subString, allowOverlapping) => {
    // This function returns the number of a substring repeated in string
    string += "";
    subString += "";
    if (subString.length <= 0) return string.length + 1;
    const stringInLowerCase = string.toLowerCase();
    const subStringInLowerCase = subString.toLowerCase();
    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = stringInLowerCase.indexOf(subStringInLowerCase, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  };

  useEffect(() => {
    if (searchTerms.length > 0) {
      const searchTermsArray = [];
      searchTerms?.map((term) => {
        const termArray = term.toLowerCase().split(" and ");
        if (termArray.indexOf("and")) {
          termArray.map((subTerm) => {
            if (subTerm !== "and" && !searchTermsArray.includes(subTerm)) {
              searchTermsArray.push(subTerm);
            }
          });
        } else {
          searchTermsArray.push(term);
        }
      });

      setArticleSearchedTerms(searchTermsArray);
    }
  }, [searchTerms]);

  useEffect(() => {
    if (title?.length > 0 && articleSearchedTerms?.length > 0) {
      let modifiedSortedArray = [];
      const helperArray = articleSearchedTerms?.map((tag) => {
        const count = occurrences(title, tag) + occurrences(fullDescription?.replace(/<[^>]*>/g, ""), tag);
        return { tag, count };
      });

      const sortedHelperArray = helperArray.sort((a, b) => {
        return b.count - a.count;
      });

      sortedHelperArray.map((item) => {
        if (item.count > 0) modifiedSortedArray.push(item.tag);
      });

      setModifiedArticleSearchedTerms(modifiedSortedArray.slice(0, 3));
    }
  }, [articleSearchedTerms]);

  return (
    <BlogItemWrapper
      id={articleId ? articleId : "CheckBlogItem"}
      isChecked={isChecked}
      isBeingDragged={isBeingDragged}
      SmallBlog={smallBlog}
      isPreview={preview} // for setting small sizes and checking if being dragged
      imgHeightSm={imgHeightSm}
    >
      <div
        {...(props.checkBlogId ? { id: "checkBlogIdOnBoarding" } : {})}
        className={`Hero-Start wrapper ${is_loading ? "disabled" : ""} ${
          is_removingFailed ? "remove-failed" : ""
        } ${isChecked ? "checked" : ""}`}
      >
        <div
          className="img-div"
          ref={imgDiv}
          onClick={() => {
            openArticleSidebarPreview({
              articleId,
              title,
              website,
              imgUrl,
              tags: entities,
              publishDate,
            });
          }}
        >
          {isBeingDragged && selectedArticle > 1 && (
            <>
              <LazyLoadImage
                src={getImageUrl(imgUrl, imgWidth, imgHeight, articleId)}
                alt=""
                className="img-responsive layered-img-2"
                style={{ height: imgHeight + "px" }}
              />
              <LazyLoadImage
                src={getImageUrl(imgUrl, imgWidth, imgHeight, articleId)}
                alt=""
                className="img-responsive layered-img-1"
                style={{ height: imgHeight + "px" }}
              />
            </>
          )}
          <div
            className="background-image-style"
            style={{ backgroundImage: `url(${getImageUrl(imgUrl, imgWidth, imgHeight, articleId)})` }}
          >
            <LazyLoadImage
              src={getImageUrl(imgUrl, imgWidth, imgHeight, articleId)}
              alt=""
              className="img-responsive"
              style={preview ? {} : { height: imgHeight + "px", width: "100%" }}
            />
          </div>
        </div>
        <div className="banner-left-icons">
          <Space size="small">
            <LargeCheckBox
              isChecked={isChecked || preview}
              SetIsChecked={(e) => curateCheckBlog(e)}
              isSmall={preview}
              {...(props.checkboxId ? { id: props.checkboxId } : {})}
            />
            {isCMS && ( // If that article is already added by the user through CMS, My CMS pill will be displayed on the article
              <CMSPill />
            )}
          </Space>
        </div>
        <div className="banner-right-icons">
          {categoryTitle !== undefined && (
            <div
              className="category-title"
              style={{ backgroundColor: categoryColor !== undefined ? categoryColor[0].color : "" }}
            >
              {categoryTitle[0].alert}
            </div>
          )}
          {(inEditionSmartSourced || isFavoritesPage) && isCurated ? (
            <div className="curated-pill-wrapper">
              <CuratedPill />
            </div>
          ) : (
            (inEditionSmartSourced || isFavoritesPage) && (
              <LazyLoadImage
                onClick={() =>
                  addArticleToDraft(articleId, {
                    id: articleId,
                    title: title,
                    description: description,
                    image_url: imgUrl,
                    website: website,
                    publish_date: publishDate,
                    is_favourite: isFav,
                    is_curated: isCurated,
                    is_checked: false,
                    entities: entities,
                    link: link,
                  })
                }
                style={{ cursor: "pointer", height: 22, width: 22, marginRight: 5 }}
                src={AddIcon}
                alt="add icon"
              />
            )
          )}
        </div>

        {/*  curated article count */}
        {isBeingDragged && selectedArticle > 1 && <div className="article-count-circle">3</div>}
        <div className="content-div-wrapper" style={{ position: "relative" }}>
          {isBeingDragged && selectedArticle > 1 && (
            <>
              {/* third layered content div */}
              <div className="content-div padding-lg content-layered-2">
                <div
                  className="content"
                  onClick={() => {
                    openArticleSidebarPreview({
                      articleId,
                      title,
                      website,
                      imgUrl,
                      tags: entities,
                      publishDate,
                      entities,
                    });
                  }}
                >
                  <h4 className="title">{title}</h4>
                  <div className="desc">
                    <span className="website-link padding-sm">{website}</span>|
                    <span className="published-time padding-sm">{publishDate}</span>
                    {companyName && (
                      <>
                        |<span className="tags padding-sm"> {companyName}</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="Blog-menu-icon">
                  <ShareMenuPopup
                    isFav={props.isFav}
                    id={props.articleId}
                    isCurated={props.isCurated}
                    data={props}
                  >
                    <div className="padding-sm text-center">
                      <img src={MenuIcon} alt="menu" />
                    </div>
                  </ShareMenuPopup>
                  {/* {companyLogo ? (
                    <div className="company-logo">
                      <img src={companyLogo} alt="logo" />
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>
              {/* third layered div ends here */}

              {/* second layered content div */}
              <div className="content-div padding-lg content-layered-1">
                <div
                  className="content"
                  onClick={() => {
                    openArticleSidebarPreview({
                      articleId,
                      title,
                      website,
                      imgUrl,
                      tags: entities,
                      publishDate,
                      entities,
                    });
                  }}
                >
                  <h4 className="title">{title}</h4>
                  <div className="desc">
                    <span className="website-link padding-sm">{website}</span>|
                    <span className="published-time padding-sm">{publishDate}</span>
                    {companyName && (
                      <>
                        |<span className="tags padding-sm"> {companyName}</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="Blog-menu-icon">
                  <ShareMenuPopup
                    isFav={props.isFav}
                    id={props.articleId}
                    isCurated={props.isCurated}
                    data={props}
                  >
                    <div className="padding-sm text-center">
                      <img src={MenuIcon} alt="menu" />
                    </div>
                  </ShareMenuPopup>
                  {companyLogo ? (
                    <div className="company-logo">
                      <img src={companyLogo} alt="logo" />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* second layered div ends here */}
            </>
          )}

          <div className="content-div padding-lg">
            <div
              className="content"
              onClick={() => {
                openArticleSidebarPreview({
                  articleId,
                  title,
                  website,
                  imgUrl,
                  tags: entities,
                  publishDate,
                  entities,
                });
              }}
            >
              <h4 className="title">{title}</h4>
              <div className="desc">
                <span className="website-link padding-sm">{website}</span>|
                <span className="published-time padding-sm">{publishDate}</span>
                {!window.location.pathname.startsWith("/content/myaccounts") && (
                  <>
                    {modifiedArticleSearchedTerms.length > 0 && <>|</>}
                    <span className="published-time padding-sm">
                      {modifiedArticleSearchedTerms?.map((tag, index) => {
                        return (
                          <span key={index} className="green-text-style">
                            {`${index > 0 ? "," : ""} ${tag}`}
                            <span className="black-text-style">{` (${
                              occurrences(title, tag) + occurrences(fullDescription?.replace(/<[^>]*>/g, ""), tag)
                            })`}</span>
                          </span>
                        );
                      })}
                    </span>
                  </>
                )}
                {companyName && (
                  <>
                    |<span className="tags padding-sm"> {companyName}</span>
                  </>
                )}
              </div>
            </div>
            <div
              className="d-flex align-content-start align-items-end flex-wrap align-self-end justify-content-end"
              style={{ minWidth: "68px" }}
            >
              {isFav ? (
                <i
                  style={{ cursor: "pointer", marginBottom: -7 }}
                  className={"article-fav-icon"}
                  onClick={() => removeFavoriteArticle(articleId)}
                >
                  <FavouriteIconTwo />
                </i>
              ) : (
                <i
                  style={{ cursor: "pointer", marginBottom: -7 }}
                  className={"article-fav-icon"}
                  onClick={() => addFavouriteArticle(articleId)}
                >
                  <FavouriteIcon />
                </i>
              )}
              <div className="Blog-menu-icon">
                <ShareMenuPopup isFav={props.isFav} id={props.articleId} isCurated={props.isCurated} data={props}>
                  <div style={{ marginBottom: -7 }} className="padding-sm">
                    <img src={MenuIcon} alt="menu" />
                  </div>
                </ShareMenuPopup>
              </div>
            </div>
            <div
              className="devider-color"
              style={{ backgroundColor: categoryColor !== undefined ? categoryColor[0].color : "" }}
            ></div>
          </div>
        </div>
      </div>
    </BlogItemWrapper>
    //   </div>
    // </div >
  );
};
export default CheckBlogItem;

CheckBlogItem.defaultProps = {
  // imgUrl: "",
  imgUrl:
    "https://image.freepik.com/free-photo/abstract-surface-textures-white-concrete-stone-wall_74190-8184.jpg",

  title: "Article title goes here and can be up to two lines long if necessary, after that truncate…",
  website: "forbes.com",
  publishDate: "2 min ago",
  tags: "Design, Strategy, Behavioural Economics",
  smallBlog: false,
};
const BlogItemWrapper = styled.div`
  height: 100%;
  .green-text-style {
    font-family: "Roboto";
    font-weight: 500;
    color: #27ce0a;
    /* font-size: 12px; */
    text-transform: capitalize;
    .black-text-style {
      color: #424b50;
    }
  }
  .checked {
    box-shadow: ${(props) => (props.isPreview ? "0 0 0 3px #27CE0A !important" : "0 0 0 4px #27CE0A !important")};
  }
  .wrapper ${(props) =>
    !props.isPreview
      ? `{
    position: relative;
    z-index: 1;
    .curated-pill-wrapper {
      position: absolute;
      top: 0px;
      right: 15px;
      z-index: 1;
    }
    .article-count-circle {
      z-index: 1;
      height: 60px;
      width: 60px;
      background-color: #27CE0A;
      position: absolute;
      top: -15px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 49px;
      right: -15px;
      color: #fff;
    }
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    position: relative;
    border-radius: 8px;
    height: 100%;    
    .img-div {
      .background-image-style{
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        min-height: 185px;
        @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
          min-height: unset;
        }
        img{
          opacity:0;
        }
      }
      img {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        min-width: 100%;
        border: ${props.isBeingDragged ? "solid 2px #27CE0A" : "none"};
        position: relative;
        border-bottom: none;
        z-index: 1;
        max-width: 100%;
        pointer-events: none;
        @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
          // height: 195px !important;
          // height: 175px !important;
          height: ${props.imgHeightSm} !important;
          
        }
      }
      .layered-img-1 {
        position: absolute;
        left: -11px;
        border: solid 5px #27CE0A;
        border-bottom: none;
        top: 10px;
      }
      .layered-img-2 {
        position: absolute;
        left: -20px;
        border: solid 4px #27CE0A;
        border-bottom: none;
        top: 23px;
      }
    }
    .add-icon {
      position: absolute;
      top: 15px;
      right: 15px;
      :hover {
        cursor: pointer;
      }
    }
    .banner-right-icons {
      display: flex;
      position: absolute;
      top: 15px;
      right: 15px;
      padding-top: 3px;
      z-index: 1;
      .category-title{
        border-radius:15px;
        color:#FFFFFF;
        font-weight:500;
        padding:2px 10px;
        line-height:18px;
        height:22px;
        font-family: "Roboto", sans-serif;
        white-space: nowrap;
      }
    }
    .banner-left-icons {
      display: flex;
      position: absolute;
      top: 15px;
      left: 15px;
      padding-top: 3px;
      z-index: 1;
      .article-fav-icon {
        @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
          img{
            width:17px;
            height:17px;
          }
        }
      }
      .content-engagement-pill-wrapper {
        margin-left: 4px;
        margin-right: 4px;
      }
    }
    .content-div {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      border: ${props.isBeingDragged ? "solid 4px #27CE0A" : "none"};
      position: relative;
      z-index: 1;
      border-top: none;
      background-color: #fff;
      display: flex;
      .content {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      }
      .title {
        font-family: roboto_slabregular, sans-serif;
        font-size: 21px;
        color: #424b50;
        min-height: 50px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
          font-size: 16px;
          line-height:18px;
          min-height: 36px;
        }
      }
      .desc {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        .website-link {
          color: #db3725;
          font-family: "robotomedium", sans-serif;
          font-size: ${props.SmallBlog ? "12px" : "14px"};
          padding-left: 0;
          @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
           font-size: 10px;
            line-height:18px;
          }
        }
        .published-time {
          color: #7e7e7e;
          font-size: ${props.SmallBlog ? "12px" : "14px"};
          font-family: "robotomedium", sans-serif;
          font-weight: 400;
          @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
           font-size: 10px;
            line-height:18px;
          }
        }
        .tags {
          color: #27CE0A;
          font-family: "robotomedium", sans-serif;
          font-weight: 400;
          font-size: ${props.SmallBlog ? "12px" : "14px"};
          text-transform: capitalize;
          @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
           font-size: 10px;
            line-height:18px;
          }
        }
      }
      .article-fav-icon{
        img{
          pointer-events: auto;
          -webkit-user-drag: none;
          margin-bottom: 0px;
          width: 36px;
           @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
            margin-bottom: 1px;
            width: 26px;
           }
        }
      }
      .Blog-menu-icon {
        // align-self: flex-end;
        > div {
          cursor: pointer;
          img {
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                height: 16px;
              }
            .ant-popover .ant-popover-content .ant-popover-inner {
              border-radius: 10px;
            }
          }
        }
        .company-logo {
          align-self: flex-end;
          cursor: default;
          margin-bottom: -20px;
          padding-top: 20px;
          img {
            max-width: 40px;
          }
        }
      }
    }
    .content-layered-1 {
      position: absolute;
      top: 10px;
      background-color: #fff;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      border: solid 4px #27CE0A;
      left: -11px;
      border-top: none;
      margin-right: 10px;
    }
    .content-layered-2 {
      position: absolute;
      top: 22px;
      background-color: #fff;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      border: solid 4px #27CE0A;
      left: -20px;
      border-top: none;
      margin-right: 20px;
    }
  } 
`
      : `
  {
    border:  solid 3px #27CE0A;
    position: relative;
    z-index: 1;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    position: relative;
    border-radius: 8px;
    height: 100%;
    overflow:hidden;
    .article-fav-icon{
      img{
        width:36px;
      }
    }
    .category-title{
        border-radius:15px;
        color:#FFFFFF;
        font-weight:500;
        padding:2px 10px;
        line-height:18px;
        height:22px;
        font-family: "Roboto", sans-serif;
        white-space: nowrap;
    }
    .curated-pill-wrapper {
      position: absolute;
      top: 0px;
      right: 15px;
      z-index: 1;
    }
    .article-count-circle {
      z-index: 2;
      height: 40px;
      width: 40px;
      background-color: #27CE0A;
      position: absolute;
      top: -5px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 49px;
      right: -15px;
      color: #fff;
    }
    .img-div {
      height: 125px;
      img {
        height: 100%;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        min-width: 100%;
        border-bottom: none;
        z-index: 1;
        max-width: 100%;
      }
    }
    .banner-right-icons {
      display: flex;
      position: absolute;
      top: 5px;
      right: 5px;
      padding-top: 3px;
      z-index: 1;
      .article-fav-icon{
        img{
          pointer-events: auto;
          -webkit-user-drag: none;
        }
      }
    }
    .banner-left-icons {
      display: flex;
      position: absolute;
      top: 5px;
      left: 5px;
      padding-top: 3px;
      z-index: 1;
      .content-engagement-pill-wrapper {
        margin-left: 2px;
        margin-right: 2px;
      }
    }
    .content-div-wrapper {
      position: relative;
      // border: 2px solid #27CE0A;
      height: 75px;
      border-top: none;
      border-radius: 8px;
      .content-div {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        // border: ${props.isBeingDragged ? "solid 2px #27CE0A" : "none"};
        position: relative;
        z-index: 1;
        border-top: none;
        background-color: #fff;
        display: flex;
        padding: 0.6rem 0.9rem;

        .content {
          display: flex;
          flex-direction: column;
          flex-grow: 1;    
          padding-right: 14px;
        }
        .title {
          font-family: roboto_slabregular,sans-serif;
          font-size: 13px;
          color: #424b50;
          min-height: 30px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: bold;
          margin: 0;
          margin-bottom: 4px;
        }
        .desc {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          .website-link {
            color: #db3725;
            font-family: "robotomedium", sans-serif;
            font-size: 10px;
            padding-left: 0;
          }
          .published-time {
            color: #7e7e7e;
            font-size: 10px;
            font-family: "robotomedium", sans-serif;
            font-weight: 400;
          }
          .tags {
            color: #27CE0A;
            font-family: "robotomedium", sans-serif;
            font-weight: 400;
            font-size: 10px;
          }
        }
        .Blog-menu-icon {
          align-self: start;
          > div {
            cursor: pointer;
            img {
              .ant-popover .ant-popover-content .ant-popover-inner {
                border-radius: 10px;
              }
            }
          }
          .company-logo {
            align-self: flex-end;
            cursor: default;
            margin-bottom: -20px;
            padding-top: 20px;
            img {
              max-width: 40px;
            }
          }
        }
      }
    }
  }
  `};
  .disabled {
    pointer-events: none;

    /* for "disabled" effect */
    background: #ccc;
  }
  .remove-failed {
    /* for "disabled" effect */
    opacity: 1;
    background: #facfcf;
  }
  .layer-1 {
    position: absolute;
    top: 0;
    left: -5px;
    border: solid 2.5px #27CE0A;
    z-index: 1;
  }
  .devider-color{
    width: 8px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    border-radius: 0 0 0 8px;
  }
`;
